import React from 'react';

const MovementFilters = ({ filters, setFilters, movements }) => {
  // Calcular totales por tipo
  const totals = movements.reduce((acc, m) => {
    acc[m.movement.type] = (acc[m.movement.type] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="space-y-2">
      <div className="flex gap-2 mb-4 px-1 overflow-x-auto pb-2">
        <button
          onClick={() => setFilters(f => ({ ...f, add: !f.add }))}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${filters.add 
              ? 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <span className="w-2 h-2 rounded-full bg-green-500 dark:bg-green-400"></span>
          Altas
        </button>
        
        <button
          onClick={() => setFilters(f => ({ ...f, remove: !f.remove }))}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${filters.remove 
              ? 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <span className="w-2 h-2 rounded-full bg-red-500 dark:bg-red-400"></span>
          Bajas
        </button>
        
        <button
          onClick={() => setFilters(f => ({ ...f, modify: !f.modify }))}
          className={`px-3 py-1.5 rounded-full text-sm flex items-center gap-1.5 transition-colors whitespace-nowrap
            ${filters.modify 
              ? 'bg-yellow-100 dark:bg-yellow-900/50 text-yellow-700 dark:text-yellow-400' 
              : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`}
        >
          <span className="w-2 h-2 rounded-full bg-yellow-500 dark:bg-yellow-400"></span>
          Modificaciones
        </button>
      </div>

      {/* Contador de movimientos */}
      <div className="px-1 text-sm text-gray-500 dark:text-gray-400 flex gap-3">
        <span>{movements.length} movimientos</span>
        <span>•</span>
        <span className="text-green-600 dark:text-green-400">{totals.add || 0} altas</span>
        <span>•</span>
        <span className="text-red-600 dark:text-red-400">{totals.remove || 0} bajas</span>
        <span>•</span>
        <span className="text-yellow-600 dark:text-yellow-400">{totals.modify || 0} modificaciones</span>
      </div>
    </div>
  );
};

export default MovementFilters; 